class DefaultParams {
  constructor() {
    this.appInfo = {};
    this.baseUrl = "";
  }

  getQueryParams() {
    var url = location.href; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.split("?")[1];
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
    return theRequest;
  }

  init() {
    const { params, base_url } = this.getQueryParams();
    this.appInfo = params ? JSON.parse(decodeURIComponent(params)) : {};
    const host = window.location.host;
    this.baseUrl = base_url
      ? decodeURIComponent(base_url)
      : process.env.VUE_APP_CONSOLE_LOG === "ON" &&
        process.env.NODE_ENV === "production"
      ? "https://" + host.replace(/.*?\./, "www.")
      : process.env.VUE_APP_CONSOLE_LOG === "ON"
      ? "https:www.devtestapp.com"
      : "https://" + host.replace(/.*?\./, "api.");
  }
  getAppInfo() {
    return this.appInfo || {};
  }
  getBaseUrl() {
    return this.baseUrl;
  }
}

export default new DefaultParams();
